
import { NavLink } from "react-router-dom";

import logo from './../../assets/logo_icon.svg'
import IconArrowBack from '../../assets/icons/icon_arrow_back'

function Head() {
	const isHome = window.location.pathname === '/'
	
	return (
		<div className="head">
			<div className="head__container">
				<NavLink to="/" >
					<img className="head__logo" src={logo} alt="logo" />
				</NavLink>

				<a href="https://doc.lyntest.com" className="head__doc" target="_blank" rel="noreferrer">
					Help Center
				</a>

				{! isHome ? 
					<NavLink to="/" className="head__back">
						<IconArrowBack />
					</NavLink>
				:''}
			</div>
		</div> 
	)
}

export default Head;
